'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actionCreators = require('../../../store/actions/action-creators');

var _FollowButton = require('../FollowButton');

var _FollowButton2 = _interopRequireDefault(_FollowButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var userFollows = state.follow.userFollows;
  var _ownProps$feedUserId = ownProps.feedUserId,
      feedUserType = _ownProps$feedUserId.type,
      feedUserRelatedId = _ownProps$feedUserId.relatedId;


  var feedUserIdKey = feedUserType + '-' + feedUserRelatedId;
  var isFollowing = userFollows[feedUserIdKey] || false;

  return {
    isFollowing: isFollowing
  };
};

var matchDispatchToProps = function matchDispatchToProps(dispatch, ownProps) {
  return {
    onClickFollow: function onClickFollow(e) {
      e.preventDefault();
      var _ownProps$feedUserId2 = ownProps.feedUserId,
          feedUserType = _ownProps$feedUserId2.type,
          feedUserRelatedId = _ownProps$feedUserId2.relatedId;


      var data = {
        logData: ownProps.logData
      };

      dispatch((0, _actionCreators.toggleFollowUserIfNeeded)(feedUserType, feedUserRelatedId, data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, matchDispatchToProps)(_FollowButton2.default);